import { Box, CardContent } from '@mui/material'
import { useGetMerchantsByPaymentPlanId, useGetPaymentPlanById } from '@src/data/api/merchants-api/merchants-api'
import { Merchant } from '@src/data/types/Merchant'
import { useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'

import PromoFilters from './components/PromoFilters'
import PromoHeader from './components/PromoHeader'
import PromoMerchantsTable from './components/PromoMerchantsTable'

const BrowsePromoMerchantsPage = () => {
  const { id = '' } = useParams<{ id: string }>()

  const [merchantNameFilter, setMerchantNameFilter] = useState('')
  const [activeOnly, setActiveOnly] = useState(false)
  const sortField = 'name'
  const sortDirection: 'asc' | 'desc' = 'asc'
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)

  const [paymentPlan, isLoadingPaymentPlan] = useGetPaymentPlanById(id)
  const [merchants, isLoadingMerchants] = useGetMerchantsByPaymentPlanId(id)

  const isLoading = isLoadingPaymentPlan || isLoadingMerchants

  const filteredMerchants = useMemo(() => {
    let result = merchants

    if (merchantNameFilter) {
      const search = merchantNameFilter.trim().toLowerCase()
      result = result.filter(m => m.name?.toLowerCase().includes(search))
    }
    if (activeOnly) {
      result = result.filter(m => m.isActive)
    }
    if (sortField) {
      result = [...result].sort((a, b) => {
        const aVal = a[sortField as keyof Merchant]
        const bVal = b[sortField as keyof Merchant]
        if (aVal === bVal) return 0
        if (aVal === undefined || aVal === '') return 1
        if (bVal === undefined || bVal === '') return -1
        if (typeof aVal === 'string' && typeof bVal === 'string') {
          return sortDirection === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal)
        }
        return 0
      })
    }
    return result
  }, [merchants, merchantNameFilter, activeOnly, sortField, sortDirection])

  return (
    <Box>
      <CardContent>
        <PromoHeader promoCode={paymentPlan?.promoCode ?? ''} />
        <PromoFilters
          merchantNameFilter={merchantNameFilter}
          setMerchantNameFilter={setMerchantNameFilter}
          activeOnly={activeOnly}
          setActiveOnly={setActiveOnly}
        />
        <PromoMerchantsTable
          isLoading={isLoading}
          filteredMerchants={filteredMerchants}
          page={page}
          rowsPerPage={rowsPerPage}
          setPage={setPage}
          setRowsPerPage={setRowsPerPage}
        />
      </CardContent>
    </Box>
  )
}

export default BrowsePromoMerchantsPage
